import React from "react";
import styled from "styled-components";

const AdminBackButton = React.forwardRef(function AdminBackButton(
  {
    children,
    className,
    disabled = false,
    icon = "←",
    type = "button",
    "aria-label": ariaLabel,
    ...nativeProps
  },
  ref
) {
  return (
    <BackButton
      {...nativeProps}
      ref={ref}
      type={type}
      className={className}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      {icon ? <BackIcon aria-hidden="true">{icon}</BackIcon> : null}
      {children ? <BackLabel>{children}</BackLabel> : null}
    </BackButton>
  );
});

AdminBackButton.displayName = "AdminBackButton";

const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-height: 2.5rem;
  padding: 0.625rem 0.875rem;
  border: 1px solid rgba(148, 163, 184, 0.35);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.78);
  color: #334155;
  font: inherit;
  font-weight: 700;
  line-height: 1.2;
  cursor: pointer;
  transition:
    background-color 140ms ease,
    border-color 140ms ease,
    color 140ms ease,
    transform 140ms ease;

  &:hover:not(:disabled) {
    border-color: rgba(37, 99, 235, 0.5);
    background: rgba(37, 99, 235, 0.08);
    color: #1d4ed8;
  }

  &:active:not(:disabled) {
    transform: translateY(1px);
  }

  &:focus-visible {
    outline: 3px solid rgba(37, 99, 235, 0.3);
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

const BackIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
`;

const BackLabel = styled.span`
  min-width: 0;
`;

export default AdminBackButton;
